module.exports = __webpack_public_path__ + "img/vadzim.s__600x600.b3f5f936.jpg";